import { OnInit } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
var CheckboxInputIndraComponent = /** @class */ (function () {
    function CheckboxInputIndraComponent(fb) {
        this.fb = fb;
        this.form = this.fb.group({
            checkbox: [null]
        });
        this.label = 'Checkbox label';
        this.checked = false;
        this.align_right = false;
        this.disabled = false;
        this.propagateChange = function (n) { };
    }
    Object.defineProperty(CheckboxInputIndraComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (newValue) {
            this._value = newValue;
            this.form.patchValue({ checkbox: this.value });
            this.propagateChange(this.value);
        },
        enumerable: true,
        configurable: true
    });
    CheckboxInputIndraComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.form.get('checkbox').valueChanges.subscribe(function (newValue) {
            _this.writeValue(newValue);
        });
    };
    CheckboxInputIndraComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    CheckboxInputIndraComponent.prototype.registerOnTouched = function (fn) {
        //
    };
    CheckboxInputIndraComponent.prototype.writeValue = function (obj) {
        if (!_.isEqual(this.value, obj)) {
            this.value = obj;
        }
    };
    return CheckboxInputIndraComponent;
}());
export { CheckboxInputIndraComponent };
